import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const PATH =
  'M43.75 16.6667C28.7923 16.6667 16.6667 28.7923 16.6667 43.75C16.6667 58.7077 28.7923 70.8333 43.75 70.8333C58.7077 70.8333 70.8333 58.7077 70.8333 43.75C70.8333 28.7923 58.7077 16.6667 43.75 16.6667ZM8.33334 43.75C8.33334 24.1899 24.1899 8.33333 43.75 8.33333C63.3101 8.33333 79.1667 24.1899 79.1667 43.75C79.1667 52.0286 76.3262 59.6438 71.5668 65.6742L90.4463 84.5537C92.0735 86.1809 92.0735 88.8191 90.4463 90.4463C88.8191 92.0735 86.1809 92.0735 84.5537 90.4463L65.6742 71.5668C59.6438 76.3262 52.0286 79.1667 43.75 79.1667C24.1899 79.1667 8.33334 63.3101 8.33334 43.75Z'

const IconSearch: FC<IconProps> = props => <SvgIcon {...props} path={PATH} />

export default IconSearch
